import { Card, Col, Row } from "antd";
import userImage from "assets/user.svg";
import CardSkeletonView from "features/dashboard/components/Skeleton/skeletonView";
import { useGetDashBoardList } from "features/dashboard/use-cases/get-dashboardUserBehaviour";
import { monthNameToNumber } from "features/facilities";

import { BookingBarChart } from "./booking-user";
import { GenderPieChart } from "./gender-pieChart";
import { MoileRegisterGraph } from "./mobile-register";
export const UserBehaviorGraphView = ({
  selectedYear,
  selectedMonth,
  dateRange,
}: any) => {
  const monthNumber =
    selectedMonth === "All" || selectedMonth === null
      ? null
      : typeof selectedMonth === "string"
      ? monthNameToNumber(selectedMonth)
      : null;

  // Extract from and to dates if dateRange is valid and month is not 'All'
  const from =
    selectedMonth !== "All" &&
    selectedMonth !== null &&
    dateRange?.[0]?.isValid()
      ? dateRange[0].format("YYYY-MM-DD")
      : null;

  const to =
    selectedMonth !== "All" &&
    selectedMonth !== null &&
    dateRange?.[1]?.isValid()
      ? dateRange[1].format("YYYY-MM-DD")
      : null;

  // Custom hook to get dashboard data by flag
  const useDashboardData = (flag: string) => {
    const params: any = {
      Type: "User",
      Month: monthNumber,
      Year: selectedYear,
      Flag: flag,
    };

    if (from && to) {
      params.FromDate = from;
      params.EndDate = to;
    }

    return useGetDashBoardList(params);
  };

  const { data: activeUser, isFetching: kpiLoading } = useDashboardData("KPI");

  const { data: bookingData, isFetching: bookingLoading } =
    useDashboardData("Booking");

  const { data: registerData, isFetching: registerLoading } =
    useDashboardData("RegisteredUser");
  const { data: GenderData, isFetching: genderIsLoading } =
    useDashboardData("Gender");

  const userTitle = activeUser?.items?.[0]?.Name ?? "Active Users";
  const userValue = activeUser?.items?.[0]?.Value ?? 0;

  return (
    <div>
      <Row
        gutter={[16, 16]}
        style={{ marginBottom: 24 }}
        className="card_row_main"
      >
        {kpiLoading ? (
          <CardSkeletonView />
        ) : (
          <Col span={6}>
            <Card style={{ backgroundColor: "#4470CF" }} className="bh_card">
              <div>
                <span style={{ fontSize: 16, color: "#fff" }}>{userTitle}</span>
                <div className="use_bx_b">
                  <h4 style={{ fontSize: 28, margin: 0, color: "#fff" }}>
                    {userValue}
                  </h4>
                  <img src={userImage} alt="user" />
                </div>
              </div>
            </Card>
          </Col>
        )}
      </Row>
      <Row gutter={[16, 16]} className="graph_row">
        <Col span={12}>
          {registerLoading ? (
            <CardSkeletonView />
          ) : (
            <Card title="Mobile Registrations">
              <MoileRegisterGraph data={registerData} />
            </Card>
          )}
        </Col>
        <Col span={12}>
          {bookingLoading ? (
            <CardSkeletonView />
          ) : (
            <Card title="Bookings">
              <BookingBarChart bookingdata={bookingData} />
            </Card>
          )}
        </Col>
        <Col span={12}>
          {genderIsLoading ? (
            <CardSkeletonView />
          ) : (
            <Card title="Gender">
              <GenderPieChart data={GenderData} />
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};
